export default __webpack_public_path__ + "static/network-4-cb27004e01385e2086cf9672ed272cbf.png";